
import Vue from 'vue'
import { TranslationFileDetails } from '../../activities.types';
import Status from './Status.vue'

export default Vue.extend({
  components: { Status },
  props: {
    availableFiles: { type: Array as () => TranslationFileDetails[], default: () => [] }
  },
  methods: {
    removeFiles(file: TranslationFileDetails) {
      this.$emit('removeFiles', file)
    }
  }
})
